const residentLandlinePageData = {
  slug: "resident-landline",
  title: "RESIDENT Landline",
  introduction:
    "Our RESIDENT Landline database contains over 8 million telephone numbers where the head of household has given consent to be contacted by third parties — regularly screened to meet regulatory compliance standards.",
  hero: {
    eyebrow: "Telemarketing & Outreach Data",
    align: "left",
    highlights: [
      { value: "8M+", label: "Compliant landline numbers" },
    ],
    cta: { label: "Enquire now", href: "#enquiry" },
  },

  sections: [
    {
      id: "compliant-up-to-date",
      variant: "feature",
      icon: "phone",
      title: "Legally Compliant, Always Up to Date",
      content: [
        "Using landline data for telemarketing must be legally compliant. Many consumers change their preferences daily, so keeping your prospect data up to date and accurate is highly important and reduces your risk of regulatory enforcement action.",
      ],
    },
    {
      id: "targeted-outreach",
      title: "Powerful, Targeted Consumer Outreach",
      titleDivider: true,
      content: [
        "When you use data for telemarketing, you're getting one of the most powerful tools for businesses for direct consumer outreach. You can enhance your chances of conversion success by targeting individuals by their lifestyle and behavioural attributes to closely match your product and service offering.",
        "Better targeting means enhancing your potential to engage with and build real relationships with people who resonate with your offering.",
      ],
    },
    {
      id: "data-quality",
      title: "Why Data Quality Matters",
      titleDivider: true,
      content: [
        "The quality of the data is highly important. High-quality telephone data ensures you're reaching the right audience, reducing wasted effort, and maximising your marketing ROI.",
      ],
    },

    {
      type: "benefits",
      variant: "outcomes",
      heading: "Key Benefits",
      titleDivider: true,
      items: [
        {
          title: "Over 8m compliant landline numbers",
        },
        {
          title: "Direct outreach at scale",
          description:
            "Reaching consumers by telephone allows an immediate engagement opportunity.",
        },
        {
          title: "Targeting that works",
          description:
            "Whether by age, household income, or location, segmented lists make your outreach more relevant and persuasive.",
        },
        {
          title: "Faster ROI",
          description:
            "Buying a phone number provides immediate opportunities for sales calls, appointment setting, and pipeline building.",
        },
        {
          title: "Multi-channel potential",
          description:
            "Combine phone calls with email or direct mail for higher engagement rates and better conversion.",
        },
      ],
    },

    {
      id: "cta-highlight",
      variant: "feature",
      icon: "phone",
      title: "Get Started",
      content: [
        "Get in touch to find out how RESIDENT Landline can support your telemarketing and outreach campaigns.",
      ],
      cta: { label: "Enquire now", href: "#enquiry" },
    },
  ],

  // No fixed pricing model exists for this service.
  pricing: null,

  enquiryForm: {
    enabled: true,
    serviceName: "RESIDENT Landline",
    anchorId: "enquiry",
    heading: "Enquire now",
  },

  seo: {
    title: "RESIDENT Landline - Lloyd James Data Consultancy",
    description:
      "RESIDENT Landline gives you access to over 8 million consent-based, compliant landline numbers for targeted telemarketing and consumer outreach campaigns.",
    keywords:
      "RESIDENT landline, landline data, telemarketing data, telephone data, compliant telephone numbers, consumer outreach, Lloyd James",
    canonical: "/resident-landline/",
  },
};

export default residentLandlinePageData;
